import { useUnsafeEffect } from '@factorialco/deprecated-design-system'
import orderBy from 'lodash/orderBy'

import MultipleChoice from 'modules/core/components/Filter/filters/MultipleChoice'
import i18n from 'modules/core/lib/i18n'

import { CostCenter } from 'modules/finance/components/FinancialWorkspace/Providers/FiltersProvider/types'

interface Props {
  defaultOpen?: boolean
  costCenters: CostCenter[]
  defaultCostCenterIds?: string[]
  selectedCostCenterIds?: string[]
  onChange: (value?: string[]) => void
  composeActiveLabel?: (value: string[]) => string
}

export const CostCenterSelector = ({
  onChange,
  costCenters,
  defaultOpen,
  composeActiveLabel,
  defaultCostCenterIds,
  selectedCostCenterIds,
}: Props) => {
  const sortedCostCenters = orderBy(costCenters, (costCenter) => costCenter.name, ['asc'])

  const handleOnChange = (value?: string[]) => {
    const values = value
      ?.map((item) => costCenters.find((cc) => cc.id === String(item))?.id)
      .filter((i) => i !== undefined)

    onChange(values)
  }

  const costCenterOptions = sortedCostCenters.map((cc) => ({
    value: cc.id.toString(),
    label: cc.name,
  }))

  // set default value as current value if there is no current value
  useUnsafeEffect(() => {
    if (
      defaultCostCenterIds?.length &&
      !selectedCostCenterIds?.length &&
      costCenterOptions?.length
    ) {
      onChange(
        defaultCostCenterIds.filter((id) =>
          costCenterOptions.find((option) => option.value === id.toString())
        )
      )
    }
  }, [costCenterOptions, onChange, defaultCostCenterIds, selectedCostCenterIds])

  const value = selectedCostCenterIds
    ?.filter((i) => costCenterOptions.find((option) => option.value === i.toString())?.value)
    ?.map((i) => String(i))

  return (
    <MultipleChoice
      value={value}
      defaultOpen={defaultOpen}
      options={costCenterOptions}
      onValueChange={handleOnChange}
      label={i18n.t('bookkeepers.incidence.filters.types.cost_center')}
      composeActiveLabel={composeActiveLabel ? () => composeActiveLabel(value || []) : undefined}
    />
  )
}
